import { useEffect, useState } from 'react'
import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride'
import { useAdminStore } from '@/store/adminStore'
import { useTranslation } from 'react-i18next'

export function TimetableOverviewTour() {
  const { timetableOverviewTour, completeTimetableOverviewTour, nextTimetableOverviewStep } = useAdminStore()
  const { t } = useTranslation('tour')

  const [isRunning, setIsRunning] = useState(false)
  
  // Start tour when timetableTour.isActive changes
  useEffect(() => {
// console.log('TimetableOverviewTour useEffect:', { 
    //   isActive: timetableOverviewTour.isActive, 
    //   isRunning, 
    //   hasCompleted: timetableOverviewTour.hasCompleted 
    // })
    
    if (timetableOverviewTour.isActive && !isRunning && !timetableOverviewTour.hasCompleted) {
  // console.logTimetableOverviewTour: Starting tour...')
      setIsRunning(true)
    } else if (!timetableOverviewTour.isActive && isRunning) {
  // console.logTimetableOverviewTour: Tour not active, stopping...')
      setIsRunning(false)
    }
  }, [timetableOverviewTour.isActive, isRunning, timetableOverviewTour.hasCompleted])

  // Reset state when tour becomes inactive
  useEffect(() => {
    if (!timetableOverviewTour.isActive && isRunning) {
      setIsRunning(false)
    }
  }, [timetableOverviewTour.isActive, isRunning])

  const steps: Step[] = [
    {
      target: 'body',
      content: t('admin.timetableOverviewTour.steps.welcome.content'),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '[data-tour="timetable-stats"]',
      content: t('admin.timetableOverviewTour.steps.timetableStats.content'),
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      target: '[data-tour="generate-timetable"]',
      content: t('admin.timetableOverviewTour.steps.generateTimetable.content'),
      placement: 'left',
    },
    {
      target: '[data-tour="view-timetable"]',
      content: t('admin.timetableOverviewTour.steps.viewTimetable.content'),
      placement: 'right',
    },
    {
      target: '[data-tour="current-timetable"]',
      content: t('admin.timetableOverviewTour.steps.currentTimetable.content'),
      placement: 'top',
    },
    {
      target: '[data-tour="timetable-utilization"]',
      content: t('admin.timetableOverviewTour.steps.timetableUtilization.content'),
      placement: 'bottom',
    },
   
  ]

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, type } = data
    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED]

    if (finishedStatuses.includes(status)) {
      setIsRunning(false)
      completeTimetableOverviewTour()
      
      // Mark the tour as completed in localStorage
      localStorage.setItem('timetableOverviewTourCompleted', 'true')
  // console.logTimetable overview tour completed and saved to localStorage')
    } else if (type === 'step:after') {
      nextTimetableOverviewStep()
    }
  }

  // Only render if tour is active
  if (!timetableOverviewTour.isActive) {
// console.logTimetableOverviewTour: Not rendering - tour not active')
    return null
  }

  // console.log('TimetableOverviewTour: Rendering tour, isRunning:', isRunning)

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        hideBackButton
        scrollToFirstStep
        showProgress
        showSkipButton
        steps={steps}
        run={isRunning}
        stepIndex={timetableOverviewTour.currentStep}
        styles={{
          options: {
            primaryColor: '#ffffff',
            zIndex: 10000,
            arrowColor: '#ffffff',
            backgroundColor: '#ffffff',
          },
          buttonNext: {
            backgroundColor: '#ffffff',
            color: '#525FE1',
            fontSize: '16px',
            padding: '10px 20px',
            borderRadius: '6px',
          },
          buttonBack: {
            color: '#666',
            fontSize: '16px',
            padding: '10px',
            marginRight: '12px',
          },
          buttonSkip: {
            color: '#666',
            fontSize: '16px',
            padding: '10px',
          },
          tooltip: {
            padding: '24px',
            borderRadius: '12px',
            backgroundColor: '#ffffff',
            color: '#333',
            fontSize: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            maxWidth: '500px',
            minWidth: '300px',
            pointerEvents: 'auto' as const,
            transition: 'opacity 0.2s ease',
          },
          tooltipContainer: {
            textAlign: 'left' as const,
          },
          spotlight: {
            backgroundColor: 'transparent', // Completely transparent
            border: '2px solid white', // White border
            borderRadius: '8px',
            boxShadow: 'none', // Remove box shadow since we handle it in CSS
          },
        }}
        locale={{
          back: t('admin.timetableOverviewTour.locale.back'),
          close: t('admin.timetableOverviewTour.locale.close'),
          last: t('admin.timetableOverviewTour.locale.last'),
          next: t('admin.timetableOverviewTour.locale.next'),
          skip: t('admin.timetableOverviewTour.locale.skip'),
        }}
      />
      
      {/* Dark overlay for consistent darkening */}
      {isRunning && timetableOverviewTour.currentStep === 0 && (
        <div 
          className="fixed inset-0 bg-black/70 z-[9999] pointer-events-none"
          style={{ transition: 'opacity 0.2s ease' }}
        />
      )}
    </>
  )
} 